
import React from 'react';
import { supabase } from '../lib/supabase';

interface SidebarProps {
  currentPage: string;
  setCurrentPage: (page: any) => void;
  isCollapsed: boolean;
  setIsCollapsed: (collapsed: boolean) => void;
}

const Sidebar: React.FC<SidebarProps> = ({ currentPage, setCurrentPage, isCollapsed, setIsCollapsed }) => {
  const navItems = [
    { id: 'dashboard', label: 'Home', icon: 'fa-house' },
    { id: 'songs', label: 'Music', icon: 'fa-music' },
    { id: 'playlists', label: 'Lists', icon: 'fa-list-ul' },
    { id: 'ads', label: 'Ads', icon: 'fa-rectangle-ad' },
    { id: 'analytics', label: 'Stats', icon: 'fa-chart-simple' },
    { id: 'settings', label: 'Fix', icon: 'fa-gear' },
  ];

  return (
    <aside 
      className={`bg-[#0a192f] border-r border-white/5 flex flex-col z-30 transition-all duration-500 ease-in-out relative shadow-2xl ${
        isCollapsed ? 'w-20' : 'w-64'
      }`}
    >
      <button 
        onClick={() => setIsCollapsed(!isCollapsed)}
        className="absolute -right-3 top-10 bg-accent-blue text-white w-7 h-7 rounded-full flex items-center justify-center shadow-2xl border border-white/10 z-40 transition-all hover:scale-110 active:scale-90"
      >
        <i className={`fas fa-chevron-${isCollapsed ? 'right' : 'left'} text-[10px]`}></i>
      </button>

      <div className={`p-8 flex items-center ${isCollapsed ? 'justify-center' : 'space-x-4'}`}>
        <div className="w-10 h-10 flex-shrink-0 animate-float">
          <img 
            src="https://vinxbbpboupirnyxwghz.supabase.co/storage/v1/object/public/Ever-Music/file_00000000535c71f4a154bd2a598fddd0.png" 
            alt="Logo" 
            className="w-full h-full object-contain"
          />
        </div>
        {!isCollapsed && (
          <h1 className="text-2xl font-black tracking-tighter text-white uppercase overflow-hidden whitespace-nowrap">
            EVERN<span className="text-accent-cyan">X</span>
          </h1>
        )}
      </div>

      <nav className="flex-1 mt-6 px-4 space-y-2 overflow-y-auto no-scrollbar">
        {navItems.map((item) => (
          <button
            key={item.id}
            onClick={() => setCurrentPage(item.id)}
            className={`w-full flex items-center rounded-2xl transition-all duration-300 group ${
              isCollapsed ? 'justify-center p-3.5' : 'space-x-4 px-5 py-4'
            } ${
              currentPage === item.id 
                ? 'bg-accent-blue/15 text-accent-cyan shadow-lg shadow-accent-blue/5 border border-accent-blue/20' 
                : 'text-slate-400 hover:bg-white/5 hover:text-white'
            }`}
          >
            <i className={`fas ${item.icon} text-lg w-5 flex-shrink-0 text-center`}></i>
            {!isCollapsed && (
              <span className="text-sm font-bold tracking-wide transition-opacity duration-300">
                {item.label}
              </span>
            )}
          </button>
        ))}
      </nav>

      <div className="p-6 border-t border-white/5">
        <button 
          onClick={() => supabase.auth.signOut()}
          className={`w-full flex items-center rounded-2xl text-red-400/80 hover:bg-red-500/10 hover:text-red-400 transition-all ${
            isCollapsed ? 'justify-center p-3.5' : 'space-x-4 px-5 py-4'
          }`}
        >
          <i className="fas fa-power-off text-lg w-5 flex-shrink-0"></i>
          {!isCollapsed && <span className="text-sm font-bold tracking-wide">Exit</span>}
        </button>
      </div>
    </aside>
  );
};

export default Sidebar;
